export default __webpack_public_path__ + "static/media/Dr Mrunel Shetye.77464193.webp";